module.exports = __webpack_public_path__ + "static/media/Coffee.be880ff7.jpg";